import { createContext } from 'react';
import { UseMutateFunction } from 'react-query';

import { ApiRequestError } from '../../services/api';
import { User, UserBase } from '../../types/user';

export type UserContextValues = {
  user?: User;
  isLoadingUserProfile: boolean;
  isFetchingUserProfile: boolean;
  isFetchedAfterMount: boolean;
  userProfileError?: ApiRequestError;
  refetchUser: () => Promise<unknown>;
  updateUser: UseMutateFunction<UserBase | undefined, unknown, UserBase, unknown>;
  isUpdateUserLoading: boolean;
  hasUserProfile: boolean;
};

export const UserContext = createContext<UserContextValues | null>(null);
